<template>
    <v-dialog v-if="isContextMenuOpen" v-model="isContextMenuOpen">
        <v-card :style="{ height: '70vh', overflow: 'auto' }">
            <v-card-title class="secondary white--text" style="padding: 0px; font-size: 1rem;">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>Order Id:</strong> {{ orderInfo.OrderID ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>Order Status:</strong> {{ orderInfo.OrderStatus ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>Ord Load Status:</strong> {{ orderInfo.OrdLoadStatus ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>Region Name:</strong> {{ orderInfo.RegionName ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>Station Name:</strong> {{ orderInfo.StationName ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>Station City:</strong> {{ orderInfo.StationCity ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>Station Address:</strong> {{ orderInfo.StationAddress ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>Terminal Name:</strong> {{ orderInfo.TerminalName ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>RO Hours:</strong> {{ orderInfo.ROHrs ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>RT Hours:</strong> {{ orderInfo.RTHrs ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>RO Time:</strong> {{ orderInfo.ROTime ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>RT Time:</strong> {{ orderInfo.RTTime ?? "N/A" }}</div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-1">
                            <div><strong>ETA Hrs:</strong> {{ orderInfo.ETAHrs ?? "N/A" }}</div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-title>


            <v-container fluid>
                <v-row>
                    <v-col md="6">
                        <h5 :style="{ margin: '8px' }"><strong>Dispatch V2</strong></h5>
                        <div v-if="comparisonInfoV2.length <= 0" class="pa-4">
                            Order has not been assigned to V2
                        </div>
                        <v-simple-table v-else fixed-header height="400px">
                            <thead>
                                <tr>
                                    <th>Rank</th>
                                    <th>Driver</th>
                                    <th>Shift Detail</th>
                                    <th>New Available</th>
                                    <th>Hrs Available</th>
                                    <th>Distance</th>
                                    <th>Load Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in uniqueComparisonInfoV2" :key="'order-' + idx"
                                    :class="[getGoalPostClass(item.goalPost), { 'highlight-row': item.ShiftDetail === orderInfo.ShiftDetailV2 }]">
                                    <td class="text-left">{{ idx + 1 }}</td>
                                    <td class="text-left">{{ item.Driver }}</td>
                                    <td class="text-left">{{ item.ShiftDetail }}</td>
                                    <td class="text-left">{{ item.NewAvailable3 }}</td>
                                    <td class="text-left">{{ roundToTwo(item.HrsAvailable3) }}</td>
                                    <td class="text-left">{{ formatDistance(item.Distance) }}</td>
                                    <td class="text-left">{{ item.assigned_at ?? "N/A" }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col md="6">
                        <h5 :style="{ margin: '8px' }"><strong>Dispatch V3</strong></h5>
                        <div v-if="comparisonInfoV3.length <= 0" class="pa-4">
                            Order has not been assigned to V3
                        </div>
                        <v-simple-table v-else fixed-header height="400px">
                            <thead>
                                <tr>
                                    <th>Rank</th>
                                    <th>Driver</th>
                                    <th>Shift Detail</th>
                                    <th>New Available</th>
                                    <th>Hrs Available</th>
                                    <th>Distance</th>
                                    <th>Load Type</th>
                                    <th v-if="isShowReasons">Goal Post</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item, idx) in uniqueComparisonInfoV3" v-if="isShowReasons">
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <tr :key="idx" v-bind="attrs" v-on="on"
                                                :class="[{ 'highlight-row': item.ShiftDetail === orderInfo.ShiftDetail }]">
                                                <td class="text-left">{{ idx + 1 }}</td>
                                                <td class="text-left">{{ item.Driver }}</td>
                                                <td class="text-left">{{ item.ShiftDetail }}</td>
                                                <td class="text-left">{{ item.NewAvailable3 }}</td>
                                                <td class="text-left">{{ roundToTwo(item.HrsAvailable3) }}</td>
                                                <td class="text-left">{{ formatDistance(item.Distance) }}</td>
                                                <td class="text-left">{{ item.assigned_at ?? "N/A" }}</td>
                                                <td class="text-left">
                                                   <div class="d-flex align-center">
                                                        <span v-if="getGoalPostData(item.goalPost) === null " >-</span>
                                                        <span v-if="getGoalPostData(item.goalPost) !== null" class="goal-post-circle"
                                                            :class="getGoalPostClass(item.goalPost)">
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                        <div>
                                            <v-simple-table>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">Reason</th>
                                                        <th class="text-left">Value</th>
                                                    </tr>
                                                </thead>
                                                 <tbody>
                                                    <tr v-for="(reasonItem, reasonIdx) in parseReasonToArray(item.reasons)"
                                                        :key="reasonIdx">
                                                        <td>{{ reasonItem.key }}</td>
                                                        <td>{{ reasonItem.value }}</td>
                                                    </tr>
                                                 </tbody>
                                            </v-simple-table>

                                            <v-simple-table v-if="parseGoalPostToArray(item.goalPost) !== null" >
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">Goal Post Statement</th>
                                                        <th class="text-left">RT Time (in min)</th>
                                                        <th class="text-left">RO Time (in min)</th>
                                                    </tr>
                                                </thead>
                                                 <tbody>
                                                    <tr>
                                                        <td>{{ parseGoalPostToArray(item.goalPost).statement }}</td>
                                                        <td>{{ parseGoalPostToArray(item.goalPost).rtTime }}</td>
                                                        <td>{{ parseGoalPostToArray(item.goalPost).roTime }}</td>
                                                    </tr>
                                                 </tbody>
                                            </v-simple-table>
                                        </div>
                                    </v-tooltip >
                                </template>

                                <template v-else>
                                    <tr>
                                        <td class="text-left">{{ idx + 1 }}</td>
                                        <td class="text-left">{{ item.Driver }}</td>
                                        <td class="text-left">{{ item.ShiftDetail }}</td>
                                        <td class="text-left">{{ item.NewAvailable3 }}</td>
                                        <td class="text-left">{{ roundToTwo(item.HrsAvailable3) }}</td>
                                        <td class="text-left">{{ formatDistance(item.Distance) }}</td>
                                        <td class="text-left">{{ item.assigned_at ?? "N/A" }}</td>
                                    </tr>
                                </template>
</tbody>


</v-simple-table>
</v-col>
</v-row>
</v-container>
</v-card>
</v-dialog>
</template>

<script>
export default {
    name: "OrderAssignmentDetailMenu",
    props: {
        isContextMenuOpen: {
            type: Boolean,
            required: true,
        },
        comparisonInfoV2: {
            type: Array,
            required: true,
            default: () => [],
        },
        comparisonInfoV3: {
            type: Array,
            required: true,
            default: () => [],
        },
        orderInfo: {
            type: Object,
            required: true,
        },
        isShowReasons: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        uniqueComparisonInfoV2() {
            const seen = new Set();
            return this.comparisonInfoV2.filter(item => {
                if (!seen.has(item.ShiftDetail)) {
                    seen.add(item.ShiftDetail);
                    return true;
                }
                return false;
            });
        },
        uniqueComparisonInfoV3() {
            const seen = new Set();
            return this.comparisonInfoV3.filter(item => {
                if (!seen.has(item.ShiftDetail)) {
                    seen.add(item.ShiftDetail);
                    return true;
                }
                return false;
            });
        }
    },
    methods: {
        roundToTwo(value) {
            if (value === null || value === undefined || value === "") {
                return "N/A";
            }
            return Number(value).toFixed(2);
        },

        convertMinutesToHours(value){
            if (value === null || value === undefined || value === "") {
                return "N/A";
            };
            return (Number(value) / 60).toFixed(2);
        },

        getGoalPostData(goalPost){
            const parsedGoalPostData = goalPost && JSON.parse(goalPost) ? JSON.parse(goalPost) : null;
            return parsedGoalPostData;
        },      

        getGoalPostClass(goalPost) {
            const goal = this.getGoalPostData(goalPost);
            if(goalPost){
                if(goal.badge === "red") return  'goal-post-red';
                if(goal.badge === "green") return  'goal-post-green';
                if(goal.badge === "yellow") return  'goal-post-yellow';
            } else return 'goal-post-na'
        },

        parseReasonToArray(reason) {
            if (!reason) return [{ key: "No reason provided", value: "N/A" }];

            try {
                const parsed = JSON.parse(reason);
                const data = Object.entries(parsed).map(([key, value]) => ({
                    key,
                    value: JSON.stringify(value, null, 2),
                }));
                return data
            } catch (error) {
                return [{ key: "Error", value: "Invalid reason format" }];
            }
        },

        parseGoalPostToArray(goalPost){
            if(!goalPost) return null;
            try {
                const parsed = JSON.parse(goalPost);
                return {
                        statement: parsed.statement,
                        rtTime: (parsed.RTTime / 60).toFixed(2),
                        roTime: (parsed.ROTime / 60).toFixed(2)
                    }
            } catch (error) {
                return null
            }
        },

        formatDistance(value) {
            if (value === null || value === undefined || value < 0) {
                return "N/A";
            }
            return this.roundToTwo(value);
        },
    }
};
</script>

<style scoped>
.color-circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.highlight-row {
    background-color: #d4edda;
}

.highlight-green {
    background-color: #d4edda;
}

.highlight-yellow {
    background-color: #fff3cd;
}

.highlight-red {
    background-color: #f8d7da;
}

.goal-post-circle {
    display: inline-block;
    width: 12px; 
    height: 12px;
    border-radius: 50%;
    margin-left: 8px; 
}

.goal-post-green {
    background-color: #28a745; 
}

.goal-post-yellow {
    background-color: #ffc107;
}

.goal-post-red {
    background-color: #dc3545; 
}


</style>
